import { MittweidaFieldTypes } from 'mittweida/inquiry/fields';
import { StepSequence } from 'new/form/model';

export const mittweidaStepSequence: StepSequence<MittweidaFieldTypes> = [
  'financingNeedPage',
  'fundingDetailsPage',
  'userProfilePage',
  'companyDetailPage',
];
